import React, { Component } from 'react';
import { connect } from 'react-redux';

class Footer extends Component {



  render() {

    const ano = new Date().getFullYear();

    return(
      <footer id="footer">       
       
          <div className="container">
            <div className="col-md-12 text-center">
             
              <span className="copyright"> 
                  Copyright {ano} &copy; All rights reserved | Desenvolvido por Dev Team Zema
                </span>
             
            </div>
          </div>
        
      </footer>
    );
  }
}

const mapStateToProps = state => ({ login : state.login });
export default connect(mapStateToProps)(Footer);


// WEBPACK FOOTER //
// ./src/Components/Layout/Footer.js